import lodash from 'lodash';

const titleCase = (value: string | number): string => {
  const stringValue = String(value);

  if (typeof value === 'number' && !isNaN(value)) return stringValue;

  // Check if the value contains any numerical or special characters, except underscores
  if (/[^a-zA-Z\s_]/.test(stringValue)) {
    // Make the first character uppercase if it's a letter
    if (/^[a-zA-Z]/.test(stringValue)) {
      return stringValue.charAt(0).toUpperCase() + stringValue.slice(1);
    }
    return stringValue;
  }

  return lodash.startCase(value as string);
};
export default titleCase;

export const enumToTitleCase = (str: any): string => {
  if (str && !str.replace) {
    return str() || '';
  }

  return str
    .replace(/_/g, ' ')
    .split(' ')
    .map((word: string) => word[0].toUpperCase() + word.substr(1).toLowerCase())
    .join(' ');
};
